import { MapPin, Clock, Building2 } from "lucide-react";
import { EncabezadoSeccion, Reveal } from "../../shared/motion";

export default function Eventos({ datos, seccion }) {
  const eventos = datos.eventos || [];
  if (eventos.length === 0) return null;

  return (
    <section className="fe-seccion" aria-label={seccion.titulo}>
      <div className="fe-seccion-interior">
        <EncabezadoSeccion p="fe" etiqueta={seccion.etiqueta} titulo={seccion.titulo} testid="fe-titulo-eventos" />
        <div className="fe-eventos-lista">
          {eventos.map((ev, i) => (
            <Reveal key={ev.id || i} delay={i * 0.08}>
              <article className="fe-evento" data-testid={`fe-evento-${ev.id || i}`}>
                <span className="fe-evento-icono">
                  <Building2 strokeWidth={1.8} />
                </span>
                <div>
                  <p className="fe-evento-etiqueta">{ev.etiqueta}</p>
                  <h3 className="fe-evento-nombre">{ev.lugar}</h3>
                  <p className="fe-evento-detalle">
                    <Clock strokeWidth={1.8} />
                    <span>{ev.horario}</span>
                  </p>
                  <p className="fe-evento-detalle">
                    <MapPin strokeWidth={1.8} />
                    <span>{ev.direccion}</span>
                  </p>
                  {ev.urlUbicacion && (
                    <a
                      className="fe-boton fe-boton--linea"
                      href={ev.urlUbicacion}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`fe-boton-ubicacion-${ev.id || i}`}
                    >
                      <MapPin strokeWidth={1.8} />
                      {ev.textoBoton || "Cómo llegar"}
                    </a>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
